import { State } from './types';

const getters = {
  getEditUrl(state: State) {
    return state.editUrl;
  },
  getClipId(state: State) {
    return state.clipId;
  },
  getIsCLVideoReady(state: State) {
    return state.isCLVideoReady;
  },
  getClipError(state: State) {
    return state.clipError;
  },
  isClipInited(state: State) {
    return state.isCLVideoReady !== undefined;
  }
};

export default getters;
